export default "__VITE_ASSET__OvICS$TT__"